export default __webpack_public_path__ + "static/media/cutImg.b2d7e1f2.png";